<template>
  <div class="mic-com blank" :style="style">
    <div class="blank-line" :style="lineStyle" v-if="config.blank_type===0"></div>
  </div>
</template>

<script>
  import Common from '../mixins/Common';

  export default {
	name: 'Blank',
	mixins: [Common],
	methods: {},
	computed: {
	  style() {
		const {blank_type: type, block_height, line_padding} = this.config;
		return {
		  height: type === 0 ? 'auto' : block_height + 'px',
		  padding: type === 0 ? `10px ${[0, 16][line_padding]}px` : '',
		};
	  },
	  lineStyle() {
		const {line_type, line_color} = this.config;
		const borderType = ['solid', 'dashed', 'dotted'][line_type];

		return {
		  borderBottom: `1px ${borderType} ${line_color}`
		};
	  }
	}
  };
</script>

<style lang="less" rel="stylesheet/less">

  .blank {
  }
</style>
